/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";
import { useContentZone } from "cms/components/hooks/use-content-zone";

const NoComponentEditorAvailable = (props) => {
    
    const { fieldName, component, editMode } = props || {};
    const { type, guid } = component || {};
    const { handleDeleteComponent } = useContentZone();
    
    const onRemoveComponent = async () => {
        await handleDeleteComponent(fieldName, component);
    };
    
    return (
        <div className='simplicity-missing-type'>
            <span>&#128039;</span>
            <p>{type}</p>
            <p>{guid}</p>
            <p>does not have an editing component.</p>
            {editMode &&
                <Button
                    onClick={onRemoveComponent}
                    sx={{ margin: "12px" }}
                    variant='contained'
                    color='primary'
                >
                    Remove
                </Button>
            }
        </div>
    );
};

export { NoComponentEditorAvailable };
